import {
    DATA_ATTR,
    selectors,
    findChosenInsuranceRadio,
} from './shared';
import {
    triggerViewItemListInsuranceEvent,
    triggerViewItemInsuranceEvent,
    triggerUpdateCartEvent,
    triggerUserUnexpectedBehavior
} from './adobe-analytics';

function formatPrice(value) {
    const num = parseFloat(value).toFixed(2);
    const parts = num.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
}
if ($('.customRadioLabelExtras').length) {
    document.querySelectorAll('.dataInsuranceItemLi').forEach((box) => {
        box.addEventListener('click', function() {
            const radio = this.querySelector('input[type="radio"]');
            radio.checked = true;
        });
    });
    $(document).on('click', '.ipidOverlayAccordion', function(e) {
        const $current = $(this);
        const $content = $current.children('[id]');
        if ($content.length && ($content[0] === e.target || $.contains($content[0], e.target))) {
            return;
        }
        $current.find('.accordion-icon').toggleClass('show-icon');
        $content.toggleClass('hide');
    });
    if ($('.customRadioLabelExtras').length) {
        $(document).on('click', '.customRadioLabelExtras, .insuranceOptionDetailsExtras', function(e) {
            e.preventDefault();
            let dataRef = $(this).attr('data-ref');
            if ($('.insuranceExtrasSelect' + dataRef).attr('data-added') == false || $('.insuranceExtrasSelect' + dataRef).prop('checked') == false) {
                $('.insuranceExtrasSelect' + dataRef).click();
            }
        });
    }
} else {
    document.querySelectorAll('.dataInsuranceItemLi').forEach((box) => {
        box.addEventListener('click', function() {
            const radio = this.querySelector('input[type="radio"]');
            radio.checked = true;
        });
    });
}
const toggleIsLoading = (node, isLoading) => {
    isAdding = isLoading;
    const loader = document.querySelector(selectors.loader);
    if (loader) {
        loader.dataset.activeTasks = +isLoading;
    }
};
const toggleInsuranceDescriptions = (node) => {
    const insuranceTitles = node.querySelectorAll(`[${DATA_ATTR}-title]`);
    insuranceTitles.forEach((insuranceTitle) => {
        insuranceTitle.addEventListener('click', () => {
            const chosenRadio = findChosenInsuranceRadio(node);
            const hasSelected = chosenRadio && chosenRadio.value !== 'no';
            const insuranceItem = insuranceTitle.closest(selectors.insuranceItem);
            const isCollapsed = insuranceItem.dataset.insuranceItemCollapsed === 'true';
            if (hasSelected) {
                insuranceItem.dataset.insuranceItemCollapsed = !isCollapsed;
            } else {
                node.querySelectorAll(selectors.insuranceItem).forEach((item) => {
                    item.dataset.insuranceItemCollapsed = !isCollapsed;
                });
            }
        });
    });
};
const toggleFormInvalidation = (insuranceNode, isInvalid) => {
    insuranceNode.classList.toggle('is-invalid', isInvalid);
};
const resetInsuranceForm = (insuranceNode, softReset = false) => {
    const inputs = insuranceNode.querySelectorAll(softReset ? 'input[type=checkbox]' : 'input');
    const addToBasketBtn = insuranceNode.querySelector(selectors.modalAddToBasket);
    inputs.forEach((input) => {
        const formGroup = input.closest('.form-group');
        input.checked = false;
        if (!formGroup) {
            return;
        }
        formGroup.classList.remove('is-invalid');
    });
    if (addToBasketBtn) {
        addToBasketBtn.dataset.disabled = 'disabled';
    }
    insuranceNode.querySelectorAll(selectors.radio)
        .forEach((radioButton) => {
            radioButton.checked = radioButton.getAttribute('data-added') === '1';
        });
    insuranceNode.querySelectorAll(selectors.helpBlock)
        .forEach(helpBlock => helpBlock.style.display = 'none');
};
const modalCloseObserver = (insuranceNode, modal) => {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation =>
            mutation.type === 'attributes' &&
            mutation.attributeName === 'style' &&
            modal.style.display === 'none' &&
            !isAdding &&
            resetInsuranceForm(insuranceNode)
        );
    });
    observer.observe(modal, {
        attributes: true,
        childList: false,
        subtree: false
    });
};
const updateIPIDContext = (input, modal) => {
    if (!$('.customRadioLabelExtras').length) {
        const payTodayEl = modal.querySelector(`[${DATA_ATTR}-pay-today]`);
        const payMonthlyEl = modal.querySelector(`[${DATA_ATTR}-pay-monthly]`);
        const payAnnualEl = modal.querySelector(`[${DATA_ATTR}-pay-annual]`);
        const isMonthly = insuranceDuration.toUpperCase() === 'MONTHLY';
        if (isMonthly) {
            payTodayEl.textContent = `£${insurancePrice}`;
            payMonthlyEl.textContent = `£${insurancePrice}**`;
            payAnnualEl.textContent = `£${insuranceAnnualPrice}`;
        } else {
            payTodayEl.textContent = `£${insurancePrice}`;
            payMonthlyEl.textContent = '£0.00';
        }
    }
    const insuranceIdEls = modal.querySelectorAll(`[${DATA_ATTR}-id]`);
    const insuranceDocumentLink = modal.querySelector(`[${DATA_ATTR}-document]`);
    let insuranceId;
    let insurancePrice;
    let insuranceAnnualPrice;
    let insuranceDuration;
    if (!$('.customRadioLabelExtras').length) {
        ({
            dataset: {
                insuranceId,
                insurancePrice,
                insuranceAnnualPrice,
                insuranceDuration,
            }
        } = input);
    } else {
        ({
            dataset: {
                insuranceId,
                insuranceDuration,
            }
        } = input);
    }
    modal.dataset.insuranceModalContext = insuranceId.toUpperCase();
    modal.dataset.insuranceModalDuration = insuranceDuration.toUpperCase();
    insuranceDocumentLink.href = insuranceDocumentLink.getAttribute(`data-${insuranceId.toLowerCase()}-href`);
    if (!$('.customRadioLabelExtras').length) {
        const customTitle = modal.querySelector(selectors.modalTitleSource);
        if (customTitle && customTitle.textContent) {
            modal.querySelector(selectors.modalTitle).textContent = customTitle.textContent;
        }
    }
    if (!insuranceIdEls.length) {
        return;
    }
    insuranceIdEls.forEach(el => el.textContent = insuranceId.toLowerCase());
};
const bindIPIDContext = (insuranceNode, modal) => {
    const inputs = insuranceNode.querySelectorAll('input[type=radio]');
    inputs.forEach(input => input.addEventListener('click', (e) => {
        toggleFormInvalidation(insuranceNode, false);
        if (input.getAttribute('data-added') === '1') {
            e.stopPropagation();
        }
        if (input.value === 'no') {
            handleRemoveInsuranceProduct(insuranceNode, input);
            return;
        }
        const scrollableContainer = insuranceNode.querySelector(selectors.modalScrollableContainer);
        if (scrollableContainer) {
            setTimeout(() => scrollableContainer.scrollTop = 0, 1);
        }
        updateIPIDContext(input, modal);
        triggerViewItemInsuranceEvent(insuranceNode, input);
    }));
};
let consentHandlerBound = false;
const bindConsent = () => {
    if (consentHandlerBound) {
        return;
    }
    consentHandlerBound = true;
    $(document).on('input', '.basketInsuranceConsent', function() {
        const $checkbox = $(this);
        const ref = $checkbox.attr('data-ref');
        const $atb = $('.basketInsuranceAtb' + ref);
        if ($checkbox.prop('checked')) {
            $atb.removeAttr('data-disabled').removeData('disabled').prop('disabled', false);
        } else {
            $atb.attr('data-disabled', 'disabled').prop('disabled', true);
        }
    });
};
let isAdding = false;
const handleRemoveInsuranceProduct = (insuranceNode, chosenInsuranceRadio) => {
    if (!chosenInsuranceRadio) {
        return false;
    }
    if (isAdding || chosenInsuranceRadio.dataset.added === '1') {
        return false;
    }
    chosenInsuranceRadio.checked = true;
    toggleIsLoading(insuranceNode, true);
    const radioButtons = insuranceNode.querySelectorAll('input[type="radio"]');
    let insuranceIsAddedToTheBasket = false;
    radioButtons.forEach((radioButton) => {
        radioButton.disabled = true;
        if (radioButton.dataset.added === '1') {
            insuranceIsAddedToTheBasket = true;
        }
    });
    const formData = new URLSearchParams();
    formData.append('publicId', chosenInsuranceRadio.dataset.basketDealLineId);
    let updatedPrices;
    const $outerModal = $(chosenInsuranceRadio).closest('.no-insurance-selected');
    return fetch('/basket/mobile-insurance/clear', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData
    })
        .then(response => response.json())
        .then((data) => {
            if (data.shouldReloadPage) {
                return window.location.reload();
            }
            if (data.result === 'success') {
                if (insuranceIsAddedToTheBasket && data.adobeAnalyticsBasketItems) {
                    triggerUpdateCartEvent(data.adobeAnalyticsBasketItems);
                }
                insuranceNode.querySelectorAll(selectors.radio).forEach(radio => radio.dataset.added = '0');
                chosenInsuranceRadio.setAttribute('data-added', '1');
                updatedPrices = data.prices || null;
                if (data.discountWasRemoved) {
                    showDiscountRemovePopUp();
                }
                if ($('.insuranceFormBasketModal').length) {
                    $('.insuranceFormBasketModal').each(function() {
                        if (chosenInsuranceRadio.dataset.basketDealLineId == $(this).attr('data-basket-deal-line-id') && $(this).attr('data-insurance-ref') == chosenInsuranceRadio.dataset.basketDealLineId + '-no' && $('.removeBasketDeal' + $(this).attr('data-basket-deal-line-id')).length) {
                            $('.removeBasketDeal' + $(this).attr('data-basket-deal-line-id')).attr('data-analytic-insurance-item', $(this).attr('data-analytic-insurance-item'));
                        }
                    });
                }
            } else {
                throw data;
            }
        })
        .catch(() => {
            chosenInsuranceRadio.checked = false;
        })
        .finally(() => {
            radioButtons.forEach(radioButton => radioButton.disabled = false);
            toggleIsLoading(insuranceNode, false);
            resetInsuranceForm(insuranceNode, true);
            if ($outerModal.length) {
                $outerModal.modal('hide');
            }
            updatedPrices && updatePrices(updatedPrices);
            toggleFooterCTAInsurance();
        });
};

const trackConsentCheckboxesError = (consentCheckboxes) => {
    if (consentCheckboxes.length !== 2) {
        return;
    }
    if (consentCheckboxes[0].checked) {
        triggerUserUnexpectedBehavior(
            'You need to provide IPID and purchase consent to add the insurance to your basket'
        );
    } else if (consentCheckboxes[1].checked) {
        triggerUserUnexpectedBehavior(
            'You need to provide terms and conditions statement consent to add the insurance to your basket'
        );
    } else {
        triggerUserUnexpectedBehavior(
            'You need to provide both consent to add the insurance to your basket'
        );
    }
};
let basketInsuranceAtbHandlerBound = false;
let checkValidityHandlerBound = false;
const handleAddToBasket = () => {
    if (basketInsuranceAtbHandlerBound) {
        return;
    }
    basketInsuranceAtbHandlerBound = true;
    $(document).on('click', '.basketInsuranceAtb', function(e) {
        const addToBasketBtn = e.currentTarget;
        const modalRef = addToBasketBtn.getAttribute('data-modal-ref');
        const basketInsRef = addToBasketBtn.getAttribute('data-ref') || '';
        // Extras page modals use data-modal-id; basket page inline IPID divs use a plain id.
        const currentModal = document.querySelector('[data-modal-id=' + modalRef + ']')
            || document.getElementById(modalRef);
        if (!currentModal) {
            return;
        }
        const currentInsuranceNode = currentModal.closest(selectors.component);
        if (!currentInsuranceNode) {
            return;
        }
        const closeModal = currentModal.querySelector('[data-dismiss=modal]')
            || $(currentModal).closest('.no-insurance-selected').find('[data-dismiss="modal"]')[0];
        if (isAdding) {
            return false;
        }
        if (addToBasketBtn.hasAttribute('data-disabled')) {
            const consentInputs = currentModal.querySelectorAll(selectors.modalConsent);
            const errorMsg = currentModal.querySelectorAll(selectors.helpBlock);
            consentInputs.forEach((consentInput, index) => {
                errorMsg[index].style.display = consentInput.checked ? 'none' : 'block';
            });
            if (!$('.customRadioLabelExtras').length) {
                currentModal.querySelector(selectors.modalContent).scrollTo({
                    top: currentModal.scrollHeight,
                    left: 0,
                    behavior: 'smooth',
                });
            }
            trackConsentCheckboxesError(consentInputs);
            return false;
        }
        const chosenInsuranceRadio = currentInsuranceNode.querySelector(
            '[data-target="[data-modal-id=\'' + modalRef + '\']"]'
        ) || findChosenInsuranceRadio(currentInsuranceNode);
        if (!chosenInsuranceRadio) {
            return;
        }
        chosenInsuranceRadio.checked = true;
        toggleIsLoading(currentInsuranceNode, true);
        addToBasketBtn.dataset.disabled = 'disabled';
        addToBasketBtn.dataset.isAdding = true;
        const radioButtons = currentInsuranceNode.querySelectorAll(selectors.radio);
        radioButtons.forEach(radioButton => radioButton.disabled = true);
        const publicId = chosenInsuranceRadio.getAttribute('data-basket-deal-line-id');
        const dataKeys = [
            'insuranceProduct',
            'insuranceBand',
            'insuranceSyscovercode',
            'insuranceFirstPremiumPayment',
            'insuranceTotalAnnualPremium',
            'insuranceDuration',
            'insuranceIsDiscount'
        ];
        const formData = new URLSearchParams();
        formData.append('publicId', publicId);
        dataKeys.forEach((key) => {
            formData.append(
                `form[${publicId}-mobileInsurance][${key}]`,
                chosenInsuranceRadio.dataset[key]
            );
        });
        let updatedPrices;
        fetch('/basket/mobile-insurance/add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData
        })
            .then(response => response.json())
            .then((data) => {
                if (data.shouldReloadPage) {
                    return window.location.reload();
                }
                if (data.result === 'success') {
                    radioButtons.forEach(radioButton => radioButton.setAttribute('data-added', '0'));
                    chosenInsuranceRadio.setAttribute('data-added', '1');
                    currentInsuranceNode.querySelectorAll(selectors.insuranceItem).forEach((insuranceItem) => {
                        insuranceItem.dataset.insuranceItemCollapsed = true;
                    });
                    const insuranceItem = chosenInsuranceRadio.closest(selectors.insuranceItem);
                    insuranceItem.dataset.insuranceItemCollapsed = false;
                    updatedPrices = data.prices || null;
                    if (data.discountWasApplied) {
                        showDiscountPopUp();
                    }
                    if (data.discountWasRemoved) {
                        showDiscountRemovePopUp();
                    }
                    data.adobeAnalyticsBasketItems && triggerUpdateCartEvent(data.adobeAnalyticsBasketItems);
                    if (basketInsRef != '' && $('.insuranceFormBasketModal').length) {
                        $('.insuranceFormBasketModal').each(function() {
                            if (basketInsRef == $(this).attr('data-insurance-ref') && $('.removeBasketDeal' + $(this).attr('data-basket-deal-line-id')).length) {
                                $('.removeBasketDeal' + $(this).attr('data-basket-deal-line-id')).attr('data-analytic-insurance-item', $(this).attr('data-analytic-insurance-item'));
                            }
                        });
                    }
                } else {
                    throw data;
                }
            })
            .catch(() => {
                chosenInsuranceRadio.checked = false;
            })
            .finally(() => {
                addToBasketBtn.dataset.isAdding = false;
                radioButtons.forEach(radioButton => radioButton.disabled = false);
                resetInsuranceForm(currentInsuranceNode, true);
                toggleIsLoading(currentInsuranceNode, false);
                const $bootstrapModal = $(currentModal).hasClass('modal')
                    ? $(currentModal)
                    : $(currentModal).closest('.modal');
                if ($bootstrapModal.length) {
                    $bootstrapModal.modal('hide');
                } else if (closeModal) {
                    closeModal.click();
                }
                updatedPrices && updatePrices(updatedPrices);
                toggleFooterCTAInsurance();
            });
    });
};
function validateDealsOnCheckOut() {
    let returnData = 'true';
    $.ajax({
        type: 'POST',
        url: '/basket/deal/validation',
        async: false,
        dataType: 'JSON',
        success: function(res) {
            if (res.result == 'false') {
                returnData = 'false';
            }
        }
    });
    return returnData;
}
let checkedValidatePromotions = 'not-checked';
function validatePromotionsBasketOnCheckOut(e) {
    let returnData = 'true';
    if ($('.removePromotion').length) {
        let promoActionValidation = $('#revalidation').attr('href');
        let element = document.querySelector('.global-msg-boxes');
        if (promoActionValidation != '/validating' && checkedValidatePromotions == 'not-checked') {
            checkedValidatePromotions = 'checked';
            $('#revalidation').attr('href', '/validating');
            $.ajax({
                type: 'POST',
                url: promoActionValidation,
                async: false,
                context: window,
                dataType: 'JSON',
                success: function(res) {
                    if (res.result == 'success') {
                        $('.basketTotals').html(res.basketTotalsHtml);
                        $('.promoContent').html(res.promoAppliedHtml);
                        $('.global-msg-boxes').html('<div class="msg-box msg-box-warning"><span class="msg-box-icon"></span>Important: A promotion has been removed as it is no longer valid. Please check your basket for your updated payment total.</div>');
                        element.scrollIntoView(true);
                        e.stopImmediatePropagation();
                        e.preventDefault();
                        jQuery.each(res.basketLine, function(basketId, originalVal) {
                            $('.itemOriginalUpfront_' + basketId).text('');
                            $('.itemDiscountedUpfront_' + basketId).text(originalVal);
                            if ($('.itemDiscountedUpfront_' + basketId).hasClass('itemDiscountedUpfrontSingle')) {
                                $('.itemDiscountedUpfront_' + basketId).removeClass('itemDiscountedUpfrontSingle');
                            }
                            $('.itemPromoApplied_' + basketId).html('');
                            if ($('.itemPromoApplied_' + basketId).hasClass('accPromoApplied')) {
                                $('.itemPromoApplied_' + basketId).removeClass('mb-15');
                            }
                        });
                        returnData = 'false';
                    } else if (res.result != 'continue') {
                        $('.global-msg-boxes').html('<div class="msg-box msg-box-warning"><span class="msg-box-icon"></span>Important: A promotion has been removed as it is no longer valid. Please check your basket for your updated payment total.</div>');
                        element.scrollIntoView(true);
                        e.stopImmediatePropagation();
                        e.preventDefault();
                        returnData = 'false';
                    }
                },
                error: function() {
                    $('.global-msg-boxes').html('<div class="msg-box msg-box-warning"><span class="msg-box-icon"></span>A technical error has occured, please try again later.</div>');
                    element.scrollIntoView(true);
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    setTimeout(function() {
                        window.location.reload();
                    }, 3000);
                    returnData = 'false';
                }
            });
            $('#revalidation').attr('href', promoActionValidation);
        }
    }
    return returnData;
}
const checkValidityOnBasketSubmit = (e) => {
    let firstInvalidNode = null;
    const components = document.querySelectorAll(selectors.component);
    if (components) {
        for (const insuranceNode of components) {
            let dealId = insuranceNode.getAttribute('data-basket-line-id');
            const inputs = insuranceNode.querySelectorAll(selectors.radio);
            let isChosen = false;
            for (const input of inputs) {
                if (input.getAttribute('data-added') === '1') {
                    isChosen = true;
                    break;
                }
            }
            if (!isChosen) {
                firstInvalidNode = firstInvalidNode || insuranceNode;
                toggleFormInvalidation(insuranceNode, true);
                triggerUserUnexpectedBehavior('Please select an insurance option before moving forward with the checkout.');
                $('html, body').animate({
                    scrollTop: $('#' + dealId + '_uc').offset().top - 50
                }, 'slow');
                $('#noInsuranceSelected' + dealId)
                    .attr('data-insurance-modal-id', 'noInsuranceModal-' + dealId)
                    .modal('show');
                e.stopPropagation();
                e.preventDefault();
                break;
            } else {
                toggleFormInvalidation(insuranceNode, false);
            }
        }
    }
    if (firstInvalidNode) {
        e.stopImmediatePropagation();
        e.preventDefault();
        firstInvalidNode.scrollIntoView(true);
        return false;
    }
    if (validateDealsOnCheckOut() == 'false') {
        window.location.reload();
    } else if (validatePromotionsBasketOnCheckOut(e) == 'false') {
        return;
    }

};
const updateDetailContentBlocksHeight = (insuranceNode) => {
    if (window.innerWidth < 1024) {
        return;
    }
    ['.insurance-component__item-inclusions', '.insurance-component__item-exclusions'].forEach((className) => {
        let maxHeight = 0;
        const els = insuranceNode.querySelectorAll(className);
        els.forEach(el => maxHeight = Math.max(maxHeight, el.clientHeight));
        els.forEach(el => el.style.minHeight = `${maxHeight}px`);
    });
};
const showDiscountPopUp = () => {
    $('#multi-policy-discount-modal').modal('show');
};
const showDiscountRemovePopUp = () => {
    $('#multi-policy-discount-modal-remove').modal('show');
};
const updatePrices = (prices) => {
    if (!prices) {
        return;
    }
    if (prices.basketTotals) {
        const basketTotals = document.querySelector(selectors.basketTotals);
        if (basketTotals) {
            basketTotals.innerHTML = prices.basketTotals;
        }
    }
    if (prices.hasOwnProperty('insurancePrices')) {
        document.querySelectorAll(selectors.insuranceItemPrices).forEach((insurancePrice) => {
            insurancePrice.innerHTML = prices.insurancePrices[insurancePrice.dataset.basketLineId] || '';
        });
    }
    if (prices.hasOwnProperty('insuranceForms')) {
        document.querySelectorAll(selectors.component).forEach((insuranceComponent) => {
            const basketDealLineId = insuranceComponent.dataset.basketLineId;
            let updatedComponent = prices.insuranceForms[basketDealLineId];
            if (updatedComponent) {
                insuranceComponent.outerHTML = updatedComponent;
                reInitInsuranceNode(basketDealLineId);
            }
        });
    }
    if (prices.hasOwnProperty('insuranceDisplay')) {
        Object.keys(prices.insuranceDisplay).forEach((basketLineId) => {
            const updatedDisplayHtml = prices.insuranceDisplay[basketLineId];
            if (updatedDisplayHtml) {
                const $basketItemContainer = $('.basket-item-mobile-insurance').filter(function() {
                    return $(this).find('[data-basket-line-id="' + basketLineId + '"]').length > 0;
                });

                if ($basketItemContainer.length) {
                    const $modal = $basketItemContainer.find('.no-insurance-selected');
                    const isModalActive = $modal.length && ($modal.is(':visible') || $modal.hasClass('in') || $modal.hasClass('show') || $modal.css('display') !== 'none');

                    if (isModalActive) {
                        // Modal is active - defer HTML replacement until after it closes
                        $modal.one('hidden.bs.modal', function() {
                            $basketItemContainer.html(updatedDisplayHtml);
                            // Clean up backdrop only after HTML is safely replaced
                            $('.modal-backdrop').remove();
                            $('body').removeClass('modal-open').css('padding-right', '');
                        });
                    } else {
                        $basketItemContainer.html(updatedDisplayHtml);
                        // Clean up backdrop immediately when no modal is active
                        $('.modal-backdrop').remove();
                        $('body').removeClass('modal-open').css('padding-right', '');
                    }
                }
            }
        });
    }
    if (prices.hasOwnProperty('basketTotalsValues')) {
        if ($('.extrasStickyPayToday').length) {
            $('.extrasStickyPayToday').html('£' + formatPrice(prices.basketTotalsValues['Pay Today']));
            if ($('#extrasPayToday').length) {
                $('#extrasPayToday').val(formatPrice(prices.basketTotalsValues['Pay Today']));
            }
        }
        if ($('.extrasStickyPayMonthly').length) {
            $('.extrasStickyPayMonthly').html('£' + formatPrice(prices.basketTotalsValues['Pay Monthly']));
            if ($('.extrasStickyPaym').hasClass('extrasStickySimFree')) {
                if (prices.insurancePricesValues.hasOwnProperty('Monthly Cost')) {
                    if ($('.extrasStickyPaym').hasClass('hide')) {
                        $('.extrasStickyPaym').removeClass('hide');
                    }
                }
                if (!prices.insurancePricesValues.hasOwnProperty('Monthly Cost')) {
                    if (!$('.extrasStickyPaym').hasClass('hide')) {
                        $('.extrasStickyPaym').addClass('hide');
                    }
                }
            }
        }
    }
};
const ipidModalSnapshots = {};
let ipidModalResetHandlerBound = false;
const initIpidModalResetHandler = () => {
    if (ipidModalResetHandlerBound) {
        return;
    }
    ipidModalResetHandlerBound = true;
    $(document).on('hide.bs.modal', '.insurance-ipid-modal', function(e) {
        if (e.target !== this) {
            return;
        }
        const $modal = $(this);
        const modalId = $modal.attr('data-modal-id');
        if (!modalId) {
            return;
        }
        const $radio = $('[data-target="[data-modal-id=\'' + modalId + '\']"]');
        if ($radio.length && $radio.attr('data-added') === '1') {
            delete ipidModalSnapshots[modalId];
            return;
        }
        const accordions = [];
        $modal.find('.ipidOverlayAccordion').each(function() {
            accordions.push({
                open: $(this).find('.accordion-icon').hasClass('show-icon'),
            });
        });
        ipidModalSnapshots[modalId] = {
            consentChecked: $modal.find('.basketInsuranceConsent').prop('checked'),
            accordions,
        };
    });
    $(document).on('show.bs.modal', '.insurance-ipid-modal', function(e) {
        if (e.target !== this) {
            return;
        }
        const $modal = $(this);
        const modalId = $modal.attr('data-modal-id');
        Object.keys(ipidModalSnapshots).forEach(function(id) {
            if (id !== modalId) {
                delete ipidModalSnapshots[id];
            }
        });
        $modal.find('.help-block').hide();
        const snap = modalId ? ipidModalSnapshots[modalId] : null;
        if (snap) {
            const isChecked = snap.consentChecked || false;
            $modal.find('.basketInsuranceConsent').prop('checked', isChecked);
            if (isChecked) {
                $modal.find('.basketInsuranceAtb').removeAttr('data-disabled').removeData('disabled').prop('disabled', false);
            } else {
                $modal.find('.basketInsuranceAtb').attr('data-disabled', 'disabled').prop('disabled', true);
            }
            $modal.find('.ipidOverlayAccordion').each(function(i) {
                const $toggle = $(this);
                const acc = snap.accordions && snap.accordions[i];
                if (!acc) {
                    return;
                }
                if (acc.open) {
                    $toggle.find('.accordion-icon').addClass('show-icon');
                    $toggle.children('[id]').removeClass('hide');
                } else {
                    $toggle.find('.accordion-icon').removeClass('show-icon');
                    $toggle.children('[id]').addClass('hide');
                }
            });
            return;
        }
        $modal.find('.basketInsuranceConsent').prop('checked', false);
        $modal.find('.basketInsuranceAtb').attr('data-disabled', 'disabled').prop('disabled', true);
        $modal.find('.ipidOverlayAccordion').each(function() {
            $(this).find('.accordion-icon').removeClass('show-icon');
            $(this).children('[id]').addClass('hide');
        });
    });
    $(document).on('hidden.bs.modal', '.insurance-ipid-modal', function(e) {
        if (e.target !== this) {
            return;
        }
        const modalId = $(this).attr('data-modal-id');
        if (!modalId) {
            return;
        }
        const $radio = $('[data-target="[data-modal-id=\'' + modalId + '\']"]');
        if ($radio.length && $radio.attr('data-added') !== '1') {
            $radio.prop('checked', false);
            const radioName = $radio.attr('name');
            if (radioName) {
                $('input[type="radio"]').filter(function() {
                    return this.name === radioName && this.getAttribute('data-added') === '1';
                }).prop('checked', true);
            }
        }
    });
};
const reInitInsuranceNode = (basketDealLineId) => {
    const insuranceComponent = document.querySelector(
        `${selectors.component}[data-basket-line-id="${basketDealLineId}"]`
    );
    insuranceComponent && initInsuranceNode(insuranceComponent);
};
const initInsuranceNode = (insuranceNode) => {
    const modal = insuranceNode.querySelector(selectors.modal);
    toggleInsuranceDescriptions(insuranceNode);
    if (!modal) {
        return;
    }
    bindConsent();
    bindIPIDContext(insuranceNode, modal);
    modalCloseObserver(insuranceNode, modal);
    handleAddToBasket();
    updateDetailContentBlocksHeight(insuranceNode);
    if ($('.customRadioLabelExtras').length) {
        const addToBasketBtn = insuranceNode.querySelector(`[${DATA_ATTR}-add-to-basket]`);
        if (addToBasketBtn) {
            addToBasketBtn.dataset.disabled = 'disabled';
        }
    }
};
const init = () => {
    const insuranceNodes = document.querySelectorAll(selectors.component);
    if (!insuranceNodes.length) {
        return;
    }
    triggerViewItemListInsuranceEvent();
    if (!checkValidityHandlerBound) {
        checkValidityHandlerBound = true;
        $(document).on('click', selectors.basketFormButton, function(e) {
            checkValidityOnBasketSubmit(e);
        });
    }
    insuranceNodes.forEach(initInsuranceNode);
    $(document).on('click', '.no-insurance-selected input[type="radio"][value="no"]', function() {
        const radio = this;
        const insuranceNode = radio.closest(selectors.component);
        if (!insuranceNode) {
            return;
        }
        if (radio.dataset.added === '1') {
            return;
        }
        handleRemoveInsuranceProduct(insuranceNode, radio);
    });
    $(document).on('click', '[data-action="show-insurance-options"]', function() {
        const dataBasketLine = $(this).attr('data-basket-line-id');
        $('#noInsuranceSelected' + dataBasketLine).modal('hide');
        if ($('.noInsuranceSelected' + dataBasketLine).length) {
            $('.noInsuranceSelected' + dataBasketLine).click();
        }
    });
    $(document).on('click', '[data-action="continue-without-insurance"]', function() {
        const dataBasketLine = $(this).attr('data-basket-line-id');
        const redirectUrl = $(this).attr('data-redirect-url');
        // Extras page flow - has redirect URL
        if (redirectUrl) {
            const radio = document.querySelector('#insurance-option-no-insurance-' + dataBasketLine);
            const insuranceNode = radio.closest(selectors.component);
            $(this).closest('.modal').modal('hide');
            const fetchPromise = handleRemoveInsuranceProduct(insuranceNode, radio);
            if (fetchPromise && typeof fetchPromise.then === 'function') {
                fetchPromise.then(() => {
                    window.location.href = redirectUrl;
                });
            }
            return;
        }
        // Basket page flow - original logic
        const radio = document.querySelector(
            '.insuranceFormBasketModal[data-basket-deal-line-id="' + dataBasketLine + '"][data-insurance-ref="' + dataBasketLine + '-no"]'
        );
        if (!radio) {
            $('#noInsuranceSelected' + dataBasketLine).modal('hide');
            checkIfInsuranceSelected();
            return;
        }
        radio.dataset.added = '0';
        const insuranceNode = radio.closest(selectors.component);
        $('#noInsuranceSelected' + dataBasketLine).modal('hide');
        const fetchPromise = handleRemoveInsuranceProduct(insuranceNode, radio);
        if (fetchPromise && typeof fetchPromise.then === 'function') {
            fetchPromise.then(() => {
                toggleIsLoading(insuranceNode, false);
                radio.dataset.added = '1';
                checkIfInsuranceSelected();
            });
        }
    });
    initIpidModalResetHandler();
    initLearnMoreContentSwap();
    initIpidContentSwap();
    initShowDiscountRemovePopUp();
};
const isInsuranceSelectedForLine = (basketLine) => {
    const radios = document.querySelectorAll(
        `.insuranceFormBasketModal[data-basket-deal-line-id="${basketLine}"]`
    );
    for (const radio of radios) {
        if (radio.checked) {
            return true;
        }
    }
    return false;
};
const checkIfInsuranceSelected = () => {
    const removeButtons = document.querySelectorAll('.removeBasketDeal');
    const foundUnselected = [...removeButtons].some((btn) => {
        const basketLine = btn.dataset.basketLine;
        // Skip products with no insurance options (SIM-only, accessories, etc.)
        const hasInsuranceOptions = document.querySelectorAll(
            `.insuranceFormBasketModal[data-basket-deal-line-id="${basketLine}"]`
        ).length > 0;
        if (!hasInsuranceOptions) {
            return false;
        }
        const isSelected = isInsuranceSelectedForLine(basketLine);
        return !isSelected;
    });
    if (!foundUnselected) {
        $('.buttonSubmitSidebarBtn').click();
    }
};
const initShowDiscountRemovePopUp = () => {
    if ($('#basketMultiPolicyCount').length) {
        showDiscountRemovePopUp();
    }
};
const initLearnMoreContentSwap = () => {
    // Helper: enter learn-more view (removes data-dismiss so Bootstrap won't close modal)
    const enterLearnMoreView = ($modal, $learnMoreContent) => {
        const $closeBtn = $modal.find('.modal-header .close');
        const $mainContent = $modal.find('[data-insurance-main-content]');
        $closeBtn.attr('data-in-learn-more', 'true').removeAttr('data-dismiss');
        $mainContent.hide();
        $learnMoreContent.show();
        $modal.animate({
            scrollTop: 0
        }, 'slow');
    };
    // Helper: exit learn-more view (restores data-dismiss so close works normally)
    const exitLearnMoreView = ($modal) => {
        const $closeBtn = $modal.find('.modal-header .close');
        const $mainContent = $modal.find('[data-insurance-main-content]');
        const $learnMoreContents = $modal.find('[data-learn-more-content]');
        $closeBtn.removeAttr('data-in-learn-more').attr('data-dismiss', 'modal').blur();
        $learnMoreContents.hide();
        $mainContent.show();
        if (learnMoreClicked && $('[data-learn-more-target="' + learnMoreClicked + '"]').length) {
            $modal.animate({
                scrollTop: $('[data-learn-more-target="' + learnMoreClicked + '"]').offset().top
            }, 'slow');
            learnMoreClicked = '';
        }
    };
    // When "Learn more" is clicked, swap modal body content
    $(document).on('click', '.learn-more-info', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const learnMoreTargetId = $(this).data('learn-more-target');
        if (!learnMoreTargetId) {
            return;
        }
        learnMoreClicked = learnMoreTargetId;
        const $modal = $(this).closest('.modal');
        const $learnMoreContent = $modal.find('#' + learnMoreTargetId);
        if (!$learnMoreContent.length || !$modal.find('[data-insurance-main-content]').length) {
            return;
        }
        enterLearnMoreView($modal, $learnMoreContent);
    });
    // When "Back" button is clicked, restore main content
    $(document).on('click', '[data-back-to-main]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const $modal = $(this).closest('.modal');
        if (!$modal.find('[data-insurance-main-content]').length) {
            return;
        }
        exitLearnMoreView($modal);
    });
    // Close button click — if in learn-more view (data-dismiss removed, marker present),
    // behave like Back button instead of closing the modal
    $(document).on('click', '.no-insurance-selected .modal-header .close[data-in-learn-more]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const $modal = $(this).closest('.modal');
        exitLearnMoreView($modal);
        return false;
    });
    // Reset to main content when modal fully closes
    $(document).on('hidden.bs.modal', '.no-insurance-selected', function(e) {
        if (e.target !== this) {
            return;
        }
        exitLearnMoreView($(this));
    });
};
const ipidContentSnapshots = {};
let ipidSwapHandlerBound = false;
let clickedInsurance = '';
let learnMoreClicked = '';
const initIpidContentSwap = () => {
    if (ipidSwapHandlerBound) {
        return;
    }
    ipidSwapHandlerBound = true;
    // Ensure ATB and consent handlers are registered even if initInsuranceNode
    // returned early because no .insurance-ipid-modal was found at init time
    handleAddToBasket();
    bindConsent();
    const enterIpidView = ($outerModal, $ipidContent) => {
        const $closeBtn = $outerModal.find('.modal-header .close');
        const $mainContent = $outerModal.find('[data-insurance-main-content]');
        const ipidId = $ipidContent.attr('id');
        // Opening any IPID content discards snapshots of all OTHER IPID contents
        Object.keys(ipidContentSnapshots).forEach(function(id) {
            if (id !== ipidId) {
                delete ipidContentSnapshots[id];
            }
        });
        $ipidContent.find('.help-block').hide();
        const snap = ipidId ? ipidContentSnapshots[ipidId] : null;
        if (snap) {
            // Restore previous state from snapshot
            const isChecked = snap.consentChecked || false;
            $ipidContent.find('.basketInsuranceConsent').prop('checked', isChecked);
            if (isChecked) {
                $ipidContent.find('.basketInsuranceAtb').removeAttr('data-disabled').removeData('disabled').prop('disabled', false);
            } else {
                $ipidContent.find('.basketInsuranceAtb').attr('data-disabled', 'disabled').prop('disabled', true);
            }
            $ipidContent.find('.ipidOverlayAccordion').each(function(i) {
                const $toggle = $(this);
                const acc = snap.accordions && snap.accordions[i];
                if (!acc) {
                    return;
                }
                if (acc.open) {
                    $toggle.find('.accordion-icon').addClass('show-icon');
                    $toggle.children('[id]').removeClass('hide');
                } else {
                    $toggle.find('.accordion-icon').removeClass('show-icon');
                    $toggle.children('[id]').addClass('hide');
                }
            });
        } else {
            // Fresh open — reset to defaults (disabled state)
            $ipidContent.find('.basketInsuranceConsent').prop('checked', false);
            $ipidContent.find('.basketInsuranceAtb').attr('data-disabled', 'disabled').prop('disabled', true);
            $ipidContent.find('.ipidOverlayAccordion').each(function() {
                $(this).find('.accordion-icon').removeClass('show-icon');
                $(this).children('[id]').addClass('hide');
            });
        }
        $closeBtn.attr('data-in-ipid', 'true').removeAttr('data-dismiss');
        $outerModal.find('.modal-dialog').addClass('basketInsuranceIpidModal');
        $mainContent.hide();
        $ipidContent.show();
        $ipidContent.animate({
            scrollTop: $ipidContent.offset().top - 50
        }, 'slow');
    };
    const exitIpidView = ($outerModal, $ipidContent) => {
        const $closeBtn = $outerModal.find('.modal-header .close');
        const $mainContent = $outerModal.find('[data-insurance-main-content]');
        const $ipidContents = $outerModal.find('[data-ipid-content]');
        // Save snapshot before hiding (if $ipidContent provided)
        if ($ipidContent && $ipidContent.length) {
            const ipidId = $ipidContent.attr('id');
            if (ipidId) {
                const accordions = [];
                $ipidContent.find('.ipidOverlayAccordion').each(function() {
                    accordions.push({
                        open: $(this).find('.accordion-icon').hasClass('show-icon'),
                    });
                });
                ipidContentSnapshots[ipidId] = {
                    consentChecked: $ipidContent.find('.basketInsuranceConsent').prop('checked'),
                    accordions,
                };
            }
        }
        $closeBtn.removeAttr('data-in-ipid').attr('data-dismiss', 'modal').blur();
        $outerModal.find('.modal-dialog').removeClass('basketInsuranceIpidModal');
        $ipidContents.hide();
        $mainContent.show();
        if (clickedInsurance != '' && $('#' + clickedInsurance).length) {
            $outerModal.animate({
                scrollTop: $('#' + clickedInsurance).offset().top
            }, 'slow');
            clickedInsurance = '';
        }
    };
    const uncheckOpeningRadio = ($ipidContent) => {
        const ipidId = $ipidContent.attr('id');
        if (!ipidId) {
            return;
        }
        const $radio = $('input[type="radio"][data-target="' + ipidId + '"]');
        if ($radio.length && $radio.attr('data-added') !== '1') {
            $radio.prop('checked', false);
            const radioName = $radio.attr('name');
            if (radioName) {
                $('input[type="radio"]').filter(function() {
                    return this.name === radioName && this.getAttribute('data-added') === '1';
                }).prop('checked', true);
            }
        }
    };
    // Open IPID inline content when a basket-page radio with a data-target attribute is clicked.
    // Excludes extras page radios which have data-toggle="modal" and open Bootstrap modals natively.
    $(document).on('click', 'input[type="radio"][data-target]:not([data-toggle])', function() {
        const ipidTargetId = $(this).data('target');
        let $this = this;
        clickedInsurance = $(this).attr('id');
        if (!ipidTargetId) {
            return;
        }
        const $outerModal = $(this).closest('.no-insurance-selected');
        if (!$outerModal.length) {
            return;
        }
        const $ipidContent = $outerModal.find('#' + ipidTargetId);
        if (!$ipidContent.length || $ipidContent.attr('data-ipid-content') === undefined) {
            return;
        }
        enterIpidView($outerModal, $ipidContent);
        triggerViewItemInsuranceEvent($this, $this);
    });
    // Back button from IPID view
    $(document).on('click', '[data-back-from-ipid]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const $ipidContent = $(this).closest('[data-ipid-content]');
        const $outerModal = $(this).closest('.no-insurance-selected');
        if (!$outerModal.length) {
            return;
        }
        if ($ipidContent.length) {
            uncheckOpeningRadio($ipidContent);
        }
        exitIpidView($outerModal, $ipidContent);
    });
    // Close button click when in IPID view — act as Back instead of closing the modal
    $(document).on('click', '.no-insurance-selected .modal-header .close[data-in-ipid]', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const $outerModal = $(this).closest('.no-insurance-selected');
        const $currentIpid = $outerModal.find('[data-ipid-content]:visible');
        if ($currentIpid.length) {
            uncheckOpeningRadio($currentIpid);
        }
        exitIpidView($outerModal, $currentIpid);
    });
    // Reset IPID view and clear all snapshots when the outer modal fully closes
    $(document).on('hidden.bs.modal', '.no-insurance-selected', function(e) {
        if (e.target !== this) {
            return;
        }
        // Clear all IPID content snapshots when main modal closes
        Object.keys(ipidContentSnapshots).forEach(function(id) {
            delete ipidContentSnapshots[id];
        });
        exitIpidView($(this));
    });
};
export default init;

// CDMA-625 Accessibility fix to keep accordion semantics in sync
const syncInsuranceAccordionA11yState = (scope = document) => {
    scope.querySelectorAll('[data-insurance-item]').forEach((insuranceItem) => {
        const isCollapsed = insuranceItem.dataset.insuranceItemCollapsed === 'true';
        const insuranceTitle = insuranceItem.querySelector('[data-insurance-title]');
        const insurancePanel = insuranceItem.querySelector('.insurance-component__item-details');

        if (insuranceTitle) {
            insuranceTitle.setAttribute('aria-expanded', String(!isCollapsed));
        }
        if (insurancePanel) {
            insurancePanel.hidden = isCollapsed;
        }
    });
};

const syncFromEventTarget = (target, selector) => {
    const match = target.closest(selector);
    if (!match) {
        return;
    }

    const insuranceComponent = match.closest('[data-insurance-component]');
    if (insuranceComponent) {
        syncInsuranceAccordionA11yState(insuranceComponent);
    }
};

document.addEventListener('keydown', (event) => {
    const insuranceTitle = event.target.closest('[data-insurance-title][role="button"]');
    if (insuranceTitle && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        insuranceTitle.click();
    }
});

document.addEventListener('click', event =>
    syncFromEventTarget(event.target, '[data-insurance-title]'));

document.addEventListener('change', event =>
    syncFromEventTarget(event.target, 'input[type="radio"][name^="insurance-choice"]'));

// 6543 code
function toggleFooterCTAInsurance() {
    const $mainCTA = $('.main-checkout-cta');
    const $footerCTA = $('.footer-checkout-cta');
    const $footerSpace = $('.basket-footer-panel');

    if (!$mainCTA.length) {
        return;
    }

    const fullyOut = isElementFullyOutOfView($mainCTA);
    if (fullyOut) {
        $footerCTA.addClass('visible');
        $footerSpace.addClass('footer-spacing');
    } else {
        $footerCTA.removeClass('visible');
        $footerSpace.removeClass('footer-spacing');
    }
    if (window.innerWidth > 767) {
        if ($('.buttonSubmitSidebar').length) {
            $('.basket-sticky-container .buttonSubmitSidebar').attr('style', 'width: ' + $('.main-checkout-cta .buttonSubmitSidebar').outerWidth(true) + 'px !important;');
        }
    } else {
        $('.basket-sticky-container .buttonSubmitSidebar').css('width', 'auto');
    }
}
function isElementFullyOutOfView($el) {
    if (!$el.length) {
        return false;
    }
    const rect = $el[0].getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return (
        rect.bottom < 0 || rect.top > windowHeight
    );
}
// 6543 code
